<template>
    <div>
        <app-new-breadcrumb :id="this.id"></app-new-breadcrumb>
        <div class="main">
            <div class="description">
                <div class="description-inner">
                <div class="description-text">
                    <h2>{{ this.menu.title }}</h2>
                    <p v-html="htmlContent"></p>
                </div>
                <div class="description-img" v-if="this.menu.slug === this.$t('analysesSlug')">
                    <img src="https://resources.fia.ba/file/CD4CD552-A458-EF11-8B90-00155D1E1316.jpg"
                        :alt="this.menu.title">
                </div>
                <div class="description-img" v-else-if="this.menu.slug === this.$t('financialProfessionalSlug')">
                    <img src="https://resources.fia.ba/file/DD348F3D-3DEC-EE11-8B8B-00155D1E1316.jpeg"
                        :alt="this.menu.title">
                </div>
                <div class="description-img" v-else-if="this.menu.slug === this.$t('formsSlug')">
                    <img src="https://resources.fia.ba/file/56E790BC-72CF-EB11-8B80-00155D1E1252.jpg"
                        :alt="this.menu.title">
                </div>
                <div class="description-img" v-else-if="this.menu.slug === this.$t('careerSlug')">
                    <img src="https://resources.fia.ba/file/B5788088-191D-EB11-8B7C-00155D1E1137.PNG"
                        :alt="this.menu.title">
                </div>
                <div class="description-img" v-else>
                    <img src="https://resources.fia.ba/file/FF656790-54D1-EE11-8B8A-00155D1E1316.png"
                        :alt="this.menu.title">
                </div>
                </div>
            </div>
            <div class="items-list">
                <div class="items-inner">
                <div v-for="menuItem in this.children" :key="menuItem.id" :class="[
                    menu.slug === $t('financialProfessionalSlug') ? 'items-one-item' :
                        (menu.slug === $t('analysesSlug') || menu.slug === $t('activitiesRoute') || menu.slug === $t('usefulLinksRoute') ? 'items-one-item-small' : 'items-one-item-medium')
                ]">
                    <app-sub-menu-item-new :id="menuItem.id" :menu="menuItem" :isDetails="true"
                        :hierarchyLevel="hierarchyLevel">
                    </app-sub-menu-item-new>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubMenuItemNew from './SubMenuItemNew'
import { mapGetters, mapActions } from 'vuex'
import Breadcrumb from "../common/Breadcrumb.vue";

export default {
    data() {
        return {
            menu: null,
            children: null,
            htmlContent: "",
            hierarchyLevel: 0,
            defaultIndent: 10
        }
    },
    methods: {
        ...mapActions(["fetchContentById"]),
        loadData() {
            this.fetchContentById(this.id).then((contentResposnse) => {
                this.menu.title = contentResposnse.title;
                this.htmlContent = contentResposnse.content;
            });
        },

    },
    components: {
        appSubMenuItemNew: SubMenuItemNew,
        appNewBreadcrumb: Breadcrumb,
    },
    props: ["id"],
    computed: {
        ...mapGetters(["getChildrenByParentId", "getContentById", "getSelectedLanguage"]),
    },
    created() {
        this.menu = this.getContentById(this.id);
        this.children = this.getChildrenByParentId(this.id);
        this.loadData();
    },
    watch: {
        id() {
            this.menu = this.getContentById(this.id);
            this.children = this.getChildrenByParentId(this.id);
            this.loadData();
        },
        content() {
            this.loadData();
        },
        getSelectedLanguage() {
            this.loadData();
        }
    },

}
</script>

<style scoped>

.items-list {
    width: 100%;
    padding: 2% 7%;
    box-sizing: border-box;
}

.items-inner {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    row-gap: 15px;
    max-width: 1440px;
    margin: 0 auto;
}

.items-one-item {
    flex: 1 1 calc((100% - 15px)/2);
    min-width: calc((100% - 15px) /2);
    max-width: calc((100% - 15px) /2);
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease;
}

.items-one-item-medium {
    flex: 1 1 calc((100% - 30px)/3);
    min-width: calc((100% - 30px)/3);
    max-width: calc((100% - 30px)/3);
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease;
}

.items-one-item-small {
    flex: 1 1 calc((100% - 45px)/4);
    min-width: calc((100% - 45px)/4);
    max-width: calc((100% - 45px)/4);
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease;
}

.items-one-item:hover,
.items-one-item-medium,
.items-one-item-small:hover {
    transform: translateY(-2px);
}

@media only screen and (max-width: 1200px) {
    .items-inner {
        width: 100%;
    }

    .items-one-item-medium,
    .items-one-item-small {
        flex: 1 1 100%;
        min-width: calc(97%/2);
        max-width: calc(97%/2);
    }
}

@media only screen and (max-width: 768px) {

    .items-one-item,
    .items-one-item-medium,
    .items-one-item-small {
        flex: 1 1 100%;
        min-width: 100%;
        max-width: 100%;
    }

}
</style>
